import "./assets/scss/style.scss";
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import i18n, { initI18n } from './i18n'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"


initI18n().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(<App />)
})


initI18n().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(<App />)
})